import React from 'react'
import 'swiper/css'
import 'swiper/css/autoplay'
import 'swiper/css/pagination'
import { Autoplay, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import slide1image from '../../assets/slide1.webp'
import slide2image from '../../assets/slide2.webp'
import slide3image from '../../assets/slide3.webp'
import * as S from './Slider.styled'

const slides = [
  { image: slide1image, title: 'Phil DeFranco uses Fourthwall Pro to power his store' },
  { image: slide2image, title: 'Charlotte Dobre uses Fourthwall Pro to power her store' },
  { image: slide3image, title: 'Harry Mack uses Fourthwall Pro to power his store' },
]

export const Slider = () => {
  return (
    <S.Container>
      <Swiper
        modules={[Autoplay, Pagination]}
        speed={1200}
        loop
        autoplay={{
          delay: 5000,
        }}
        pagination={{
          clickable: true,
        }}
        slidesPerView={1}
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <S.SlideImage src={slide.image} />
            <S.SlideTitle>{slide.title}</S.SlideTitle>
          </SwiperSlide>
        ))}
      </Swiper>
    </S.Container>
  )
}
